<template>
  <v-card :loading="loading" :disabled="loading">
    <CardTitle :title="title ? 'Contacts: '+ title : 'Contacts'">
      <template v-slot:prepend_actions>
        <Contact :customer_id="customer_id"></Contact>
      </template>
      <template v-slot:actions>
        <slot name="title_actions"></slot>
        <v-tooltip bottom>
          <template v-slot:activator="{on}">
            <v-btn v-on="on" @click="loadData" icon><v-icon>mdi-refresh</v-icon></v-btn>
          </template>
          <span>Reload Data</span>
        </v-tooltip>
      </template>
    </CardTitle>
    <v-card-text>
        <v-data-table
            :headers="headers"
            :items="items"
            item-key="id"
        >
          <template v-slot:item.email_subscriptions="{item}">
              <v-tooltip top>
                <template v-slot:activator="{on}">
                  <v-btn @click="toggleSubscription(loadSubscription(2, item.id), item.id)" :input-value="checkEmailSub(2, item.id)" v-on="on" icon active-class="success white--text"><v-icon>mdi-credit-card</v-icon></v-btn>
                </template>
                <span>Billing</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{on}">
                  <v-btn @click="toggleSubscription(loadSubscription(3, item.id), item.id)" :input-value="checkEmailSub(3, item.id)" v-on="on" icon active-class="success white--text"><v-icon>mdi-truck</v-icon></v-btn>
                </template>
                <span>Drive Calendar</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{on}">
                  <v-btn @click="toggleSubscription(loadSubscription(8, item.id), item.id)" :input-value="checkEmailSub(8, item.id)" v-on="on" icon active-class="success white--text"><v-icon>mdi-car-info</v-icon></v-btn>
                </template>
                <span>Transport Offerings</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{on}">
                  <v-btn @click="toggleSubscription(loadSubscription(5, item.id), item.id)" :input-value="checkEmailSub(5, item.id)" v-on="on" icon active-class="success white--text"><v-icon>mdi-check</v-icon></v-btn>
                </template>
                <span>Results</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{on}">
                  <v-btn @click="toggleSubscription(loadSubscription(7, item.id), item.id)" :input-value="checkEmailSub(7, item.id)" v-on="on" icon active-class="success white--text"><v-icon>mdi-bomb</v-icon></v-btn>
                </template>
                <span>Advertisements</span>
              </v-tooltip>
          </template>
          <template v-slot:item.phone_numbers="{item}">
            <template v-if="item.phone_numbers.length > 0">
              {{formatPhoneNumber(item.phone_numbers[0].number)}}
            </template>
            <span v-else>No numbers stored.</span>
          </template>
          <template v-slot:item.edit="{item}">
            <Contact editing :customer_id="customer_id" :data="item"></Contact>
          </template>
        </v-data-table>
    </v-card-text>
    <slot name="actions"></slot>
  </v-card>
</template>

<script>
import Contact from "@/views/DirectoryV2/components/forms/Contact";
export default {
name: "Contacts",
  components: {
    Contact
  },
  data: () => ({
    loading: false,
    loadingEmailSub: {
      2: false,
      3: false,
      5: false,
      7: false,
      8: false,
    },
    headers: [
      {text: "Type", value: "contact_type.desc"},
      {text: "Subscriptions", value: "email_subscriptions"},
      {text: "Name", value: "name"},
      {text: "Phone", value: "phone_numbers"},
      {text: "Email", value: "email"},
      {text: "Alt Email", value: "alt_email"},
      {text: "Edit", value: "edit"},
    ]
  }),
  props:{
    customer_id: {
      required: true,
    },
    title:{
      required: false,
    }
  },
  computed: {
    items(){
      return this.$store.$db().model('contacts').query().where('customer_id', this.customer_id).with(['contact_type', 'phone_numbers']).all();
    }
  },
  watch:{
    customer_id(){
      if(!this.loading){
        this.loadData();
      }
    }
  },
  mounted(){
    if(!this.loading){
      this.loadData();
    }
  },
  methods:{
    async loadData(){
      this.extraData();
      this.loading = true;
      try{
        await this.$store.$db().model('contacts').api().fetch({
          where: {
            key: "customer_id",
            value: this.customer_id
          },
          with: "contactType,emailSubscriptions,phoneNumbers"
        });
      }catch(err){
        this.$store.dispatch("showError", "Failed to load data.")
      } finally {
        this.loading = false;
      }
    },
    extraData(){
      this.$store.$db().model('contactTypes').api().fetch();
    },
    loadSubscription(type, contact_id){
      let subscription = this.$store.$db().model('subscriptions').query()
          .where('email_type_id', type)
          .where('contact_id', contact_id)
      if(subscription.exists()){
        return subscription.first();
      }
      return type;
    },
    checkEmailSub(type, contact_id){
      return this.$store.$db().model('subscriptions').query()
      .where('email_type_id', type)
      .where('contact_id', contact_id)
      .exists();
    },
    async toggleSubscription(subscription, contact_id){
      try{
        if(typeof subscription === "object"){
          this.loadingEmailSub[subscription.email_type_id] = true;
          await this.$store.$db().model('subscriptions').api().destroy(subscription.id, `{contact-${subscription.contact_id}} | ${subscription.id}`)
        }else{
          this.loadingEmailSub[subscription] = true;
          await this.$store.$db().model('subscriptions').api().save({
            contact_id: contact_id,
            email_type_id: subscription,
            user_id: 1,
          })
        }
      }catch(e){
        console.log(e)
        this.$store.dispatch("showError", "Failed to subscribe/unsubscribe.")
      } finally {
        if(typeof subscription === "object"){
          this.loadingEmailSub[subscription.email_type_id] = false;
        }else{
          this.loadingEmailSub[subscription] = false;
        }
      }
    },
    formatPhoneNumber(phoneNumberString) {
      let cleaned = ('' + phoneNumberString).replace(/\D/g, '')
      let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
      if (match) {
        return '(' + match[1] + ') ' + match[2] + '-' + match[3]
      }
      return null
    }
  }
}
</script>

<style scoped>

</style>
